const API_KEY = '64422b19ff6d242b3851b117c783ec08'

const requests = {
  fetchSeasonOne: `/tv/46260/season/1?api_key=${API_KEY}&language=en-US`,
  fetchSeasonTwo: `/tv/46260/season/2?api_key=${API_KEY}&language=en-US`,
  fetchSeasonThree: `/tv/46260/season/3?api_key=${API_KEY}&language=en-US`,
  fetchSeasonFour: `/tv/46260/season/4?api_key=${API_KEY}&language=en-US`,
  fetchShippdenSpecial: `/tv/31910-naruto-shipp-den/season/0?api_key=${API_KEY}&language=en-US`,
  fetchShippden1: `/tv/31910-naruto-shipp-den/season/1?api_key=${API_KEY}&language=en-US`,
  fetchShippden2: `/tv/31910-naruto-shipp-den/season/2?api_key=${API_KEY}&language=en-US`,
  fetchShippden3: `/tv/31910-naruto-shipp-den/season/3?api_key=${API_KEY}&language=en-US`,
  fetchShippden4: `/tv/31910-naruto-shipp-den/season/4?api_key=${API_KEY}&language=en-US`,
  fetchShippden5: `/tv/31910-naruto-shipp-den/season/5?api_key=${API_KEY}&language=en-US`,

  fetchShippden6: `/tv/31910-naruto-shipp-den/season/6?api_key=${API_KEY}&language=en-US`,
  fetchShippden7: `/tv/31910-naruto-shipp-den/season/7?api_key=${API_KEY}&language=en-US`,
  fetchShippden8: `/tv/31910-naruto-shipp-den/season/8?api_key=${API_KEY}&language=en-US`,
  fetchShippden9: `/tv/31910-naruto-shipp-den/season/9?api_key=${API_KEY}&language=en-US`,
  fetchShippden10: `/tv/31910-naruto-shipp-den/season/10?api_key=${API_KEY}&language=en-US`,
  fetchShippden11: `/tv/31910-naruto-shipp-den/season/11?api_key=${API_KEY}&language=en-US`,
  fetchShippden12: `/tv/31910-naruto-shipp-den/season/12?api_key=${API_KEY}&language=en-US`,

  fetchShippden13: `/tv/31910-naruto-shipp-den/season/13?api_key=${API_KEY}&language=en-US`,
  fetchShippden14: `/tv/31910-naruto-shipp-den/season/14?api_key=${API_KEY}&language=en-US`,
  fetchShippden15: `/tv/31910-naruto-shipp-den/season/15?api_key=${API_KEY}&language=en-US`,
  fetchShippden16: `/tv/31910-naruto-shipp-den/season/16?api_key=${API_KEY}&language=en-US`,
  fetchShippden17: `/tv/31910-naruto-shipp-den/season/17?api_key=${API_KEY}&language=en-US`,

  fetchShippden18: `/tv/31910-naruto-shipp-den/season/18?api_key=${API_KEY}&language=en-US`,
  fetchShippden19: `/tv/31910-naruto-shipp-den/season/19?api_key=${API_KEY}&language=en-US`,
  fetchShippden20: `/tv/31910-naruto-shipp-den/season/20?api_key=${API_KEY}&language=en-US`,
  fetchBoruto: `/tv/70881-boruto-naruto-next-generations/season/1?api_key=${API_KEY}&language=en-US`,
}

export default requests
